import BaseComponent from './BaseComponent';

class ThemeNewsList extends BaseComponent {
    constructor(el) {
        super(el);
        this.el = el;
        this.urlParams = new URLSearchParams(window.location.search);
        this.handlePagination();
    }

    handlePagination() {
        const personalizedSelector = this.el.querySelector(`.sidebar-wizard__news-top input`);
        document.body.addEventListener('click', (e) => {
            if (!e.target.closest('#news-load-more')) {
                return;
            }
            e.preventDefault();
            e.target.classList.add('is-active');
            this.urlParams.set('offset', e.target.dataset.offset);
            fetch(`?${this.urlParams}`)
                .then(function (response) {
                    if (response.ok) {
                        return response.text();
                    }
                    return Promise.reject(response);
                })
                .then(function (html) {
                    const div = document.createElement('div')
                    div.innerHTML = html
                    e.target.outerHTML = div.querySelector('.list-teaser').innerHTML;
                })
                .catch(function (error) {
                    console.warn(error);
                });
        });
    }
}

export default ThemeNewsList;
